import script from "./Plan.vue?vue&type=script&setup=true&lang=ts"
export * from "./Plan.vue?vue&type=script&setup=true&lang=ts"

import "./Plan.vue?vue&type=style&index=0&id=353904f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353904f6"]])

export default __exports__